import { render, staticRenderFns } from "./CategoryProducts.vue?vue&type=template&id=17ed8716&scoped=true&"
import script from "./CategoryProducts.vue?vue&type=script&lang=js&"
export * from "./CategoryProducts.vue?vue&type=script&lang=js&"
import style0 from "./CategoryProducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ed8716",
  null
  
)

export default component.exports